
export default function Footer() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-stone-800 text-stone-100 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-12 h-12 rounded-full border-2 border-stone-100 flex items-center justify-center overflow-hidden">
                <img 
                  src="https://public.readdy.ai/ai/img_res/edited_f224cda341f9cf81f671bb205d8bae27_4fb6442b.jpg" 
                  alt="Legal Findings and Studies Logo" 
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <div className="text-lg font-light">Legal Findings and Studies, Lda.</div>
                <div className="text-sm text-stone-400 font-light">Expert Legal Services</div>
              </div>
            </div>
            <p className="text-stone-400 font-light">
              Professional legal services with expertise and dedication.
            </p>
          </div>
          
          <div>
            <h3 className="font-medium mb-4 text-stone-200">Services</h3>
            <ul className="space-y-2 text-stone-400 font-light">
              <li>
                <button 
                  onClick={() => scrollToSection('services')}
                  className="hover:text-stone-200 cursor-pointer transition-colors text-left"
                >
                  Legal Consultation
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('services')}
                  className="hover:text-stone-200 cursor-pointer transition-colors text-left"
                >
                  Contract Law
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('services')}
                  className="hover:text-stone-200 cursor-pointer transition-colors text-left"
                >
                  Corporate Law
                </button>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-medium mb-4 text-stone-200">Contact</h3>
            <div className="space-y-2 text-stone-400 font-light">
              <div>+(244) 923 502 981</div>
              <div>paula.lopes@legal-fin.com</div>
              <div className="pt-4">
                <a 
                  href="https://readdy.ai/?origin=logo" 
                  className="hover:text-stone-200 cursor-pointer transition-colors text-sm"
                >
                  Website Builder
                </a>
              </div>
            </div>
          </div>
        </div>
        
        <div className="border-t border-stone-700 mt-8 pt-8 text-center text-stone-400 font-light">
          <p>&copy; 2024 Paula Lopes. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
